import { combineReducers } from 'redux';
import { modalReducer, initialState as modalReducerInitialState } from './modalReducer';
import { trolleyItemsReducer, trolleyRequestsReducer } from './trolleyReducer';
export { modalReducerInitialState };
export var reducers = {
  trolleyItems: trolleyItemsReducer,
  trolley: trolleyRequestsReducer,
  trolleyModal: modalReducer
};
export default combineReducers(reducers);